export const SUBMIT_BUTTON_TEXT = "Submit";
export const DISMISS_BUTTON_TEXT = "Dismiss";
export const TIPSEEN_CLOSE_BUTTON_TEST_ID = "close-tipseen";
export const TIPSEEN_CLOSE_BUTTON_ARIA_LABEL = "Close";
